import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import AccordionComponent from "../../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "react-bootstrap";
import {
  PICKLIST_GROUP_NAME,
  RATE_TYPE,
  WEB_ROLE,
} from "../../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/Store";
import { fetchPickListByGroupName } from "../../../../../services/CaseInformationApi";
import SearchableSingleSelectDropdown from "../../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../../common/SearchableMultiSelectDropdown";
import NumberInput from "../../../../../common/NumberInput";
import FloatingLabelDatepicker from "../../../../../common/DatePicker";
import MultilineTextBox from "../../../../../common/MultilineTextBox";
import ThresholdEditableTable from "./PageThresholdEditable";
import ThresholdLineEditable from "./LineThresholdEditable";
import Loader from "../../../../../common/Loader";
import Snackbar from "../../../../../common/Snackbar";
import {
  formatAppointmentDateTime,
  formatDateTime,
} from "../../../../../utils/dateUtils";
import {
  addBillingConfig,
  fetchBillingConfigurationDetails,
  fetchUerListByTenantID,
  getBillingConfigChangeLog,
  getDoctorListByClient,
  getUserListByRoleAndClient,
  updateBillingConfig,
} from "../../../../../services/BillingConfigApi";
import ChangeLogDrawer from "./ChangeLogDrawer";
import { BILLING_CONFIG_CHANGE_LOG } from "../../actions/constant";
import BillingDataTable from "../BillingDataTable";
import { fetcheaderinfo } from "../../../../../services/UserRegistrationApi";
import CurrencyInputWithType from "../../../../../common/CurrencyInputWithType";
import { getBillingDashboardClientList } from "../../../../../services/BillingDashboardAPI";

interface UserOptiopn {
  userId?: number;
  usfUlNameRole?: string;
}

const AddUpdateConfiguration = ({ onClose, selectedData }: any) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const datePickerRef = useRef<HTMLDivElement>(null);

  const [selectedRole, setSelectedRole] = useState("");
  const [webRoleOptions, setWebRoleOptions] = useState<any[]>([]);

  const [selectedClient, setSelectedClient] = useState("");
  const [clientOptions, setClientOptions] = useState<any[]>([]);

  const [doctorOptions, setDoctorOptions] = useState<any[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<(string | number)[]>([]);

  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [user, setUser] = useState("");

  const [casePriorityOptions, setCasePriorityOptions] = useState<any[]>([]);
  const [selectedCasePriority, setSelectedCasePriority] = useState<
    string | number
  >("");
  const [caseTypeOptions, setCaseTypeOptions] = useState<any[]>([]);
  const [selectedCaseType, setSelectedCaseType] = useState<(string | number)[]>(
    [],
  );
  const [examTypeOptions, setExamTypeOptions] = useState<any[]>([]);
  const [selectedExamType, setSelectedExamType] = useState<(string | number)[]>(
    [],
  );
  const [rateType, setRateType] = useState("Fixed");

  const [selectedBaseCurrency, setSelectedBaseCurrency] = useState("USD");
  const [baseAmount, setBaseAmount] = useState<any>("");

  const [selectedClientCurrency, setSelectedClientCurrency] = useState("USD");
  const [clientAmount, setClientAmount] = useState<any>("");

  const [isInputPages, setIsInputPages] = useState<any>("Output");

  const addDays = (date: Date, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const addYears = (date: Date, years: number) => {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  };

  const [effectiveDateFrom, setEffectiveDateFrom] = useState<Date | null>(
    new Date(),
  );
  const [effectiveDateTo, setEffectiveDateTo] = useState<Date | null>(null);

  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [thresholdPageCurrency, setSelectedThresholdPageCurrency] =
    useState("");
  const [thresholdPageData, setThresholdPageData] = useState<any[]>([]);

  const [thresholdLineCurrency, setSelectedThresholdLineCurrency] =
    useState("");
  const [thresholdLineData, setThresholdLineData] = useState<any[]>([]);

  const [thresholdErrors, setThresholdErrors] = useState<string[]>([]);
  const [thresholdLineErrors, setThresholdLineErrors] = useState<string[]>([]);

  const [changeLogData, setChangeLogData] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showChangeDrawer, setShowChangeDrawer] = useState(false);

  const [createdOn, setCreatedOn] = useState("");
  const [createdBy, setCreatedBy] = useState("");

  const [showModalNew, setShowModalNew] = useState<boolean>(false);

  const [resetKey, setResetKey] = useState(0);
  const [resetKeyss, setResetKeyssss] = useState(0);
  const isEditMode = Boolean(selectedData?.billingConfigId);

  const formattedStringPerPage = thresholdPageData
    .map(
      (d) =>
        `${d.isInputPage},${d.min},${d.max},${d.baseRate},${d.clientRate},''`,
    )
    .join(" | ");

  const formattedStringPerLine = thresholdLineData
    .map((d) => `${d.min},${d.max},${d.baseRate},${d.clientRate},''`)
    .join(" | ");

  const params = {
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: userID,
    },
    caseType: {
      groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
      triggerById: userID,
    },
    examType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: userID,
    },
    casePriority: {
      groupName: PICKLIST_GROUP_NAME.Case_Priority,
      triggerById: userID,
    },
  };

  const currencyOptions = [
    {
      label: "USD",
      value: "USD",
    },
    {
      label: "INR",
      value: "INR",
    },
  ];

  const initialRateTypeRef = useRef<string | null>(null);
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    if (effectiveDateFrom && !selectedData) {
      setEffectiveDateTo(addYears(effectiveDateFrom, 1));
    }
  }, [effectiveDateFrom]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const webRoleData = await fetchPickListByGroupName(params.webRole);

        const allowedRoles = [
          WEB_ROLE.Historian,
          WEB_ROLE.Editor,
          WEB_ROLE.Record_Reviewer,
          WEB_ROLE.Transcriber,
        ];

        const filteredRoles =
          webRoleData?.filter((role: any) =>
            allowedRoles.includes(role.label),
          ) || [];

        setWebRoleOptions(filteredRoles);

        const casePriorityData = await fetchPickListByGroupName(
          params.casePriority,
        );
        setCasePriorityOptions(casePriorityData);
        if (casePriorityData) {
          setSelectedCasePriority(casePriorityData[0]?.value);
        }

        const caseTypeData = await fetchPickListByGroupName(params.caseType);
        setCaseTypeOptions(caseTypeData);

        const examTypeData = await fetchPickListByGroupName(params.examType);

        setExamTypeOptions(examTypeData);

        const clientData = await getBillingDashboardClientList();
        setClientOptions(clientData || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const fetchDoctorData = async () => {
    try {
      const doctorData = await getDoctorListByClient(selectedClient);
      setDoctorOptions(doctorData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedClient) {
      fetchDoctorData();
    }
  }, [selectedClient]);

  const fetchUserData = async () => {
    try {
      const userData = await getUserListByRoleAndClient(
        selectedClient,
        selectedRole,
      );
      setUserOptions(userData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedClient && selectedRole) {
      fetchUserData();
    }
  }, [selectedClient, selectedRole]);

  let selectedRoleLabel = webRoleOptions.find(
    (role) => role.value === selectedRole,
  )?.label;

  const isSlabDisable = selectedRoleLabel == WEB_ROLE.Record_Reviewer;

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedRole(value);
    setSelectedDoctor([]);
    setUser("");
    const selectedRoleLabel = webRoleOptions.find(
      (role) => role.value === value,
    )?.label;

    if (selectedRoleLabel != WEB_ROLE.Record_Reviewer && rateType != "Fixed") {
      setIsInputPages("Output");
      setThresholdPageData([]);
      setThresholdLineData([]);
      setSelectedThresholdPageCurrency("");
      setSelectedThresholdLineCurrency("");
      setRateType("Fixed");
    }

    if (selectedRoleLabel === WEB_ROLE.Historian) {
      setSelectedExamType([]);
    }
  };

  const [billingSnapshot, setBillingSnapshot] = useState<{
    rateType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Fixed Per Hour"
      | "Per Page"
      | "Per Line"
      | "";
    baseAmount: string | null;
    pageAmount: string | null;
    lineAmount: string | null;
    hourAmount: string | null;
    clientbaseAmount: string | null;
    clientpageAmount: string | null;
    clientlineAmount: string | null;
    clienthourAmount: string | null;
    pageType: any;
    pageSlabCurrency: string | "";
    lineSlabCurrency: string | "";
    pageSlabs: any[];
    lineSlabs: any[];
  } | null>(null);

  const getBillingDetails = async () => {
    try {
      const billingData = await fetchBillingConfigurationDetails(
        selectedData.billingConfigId,
      );

      if (billingData) {
        setSelectedRole(billingData.webRoleId ? billingData.webRoleId : null);

        setSelectedClient(billingData.clientId ? billingData.clientId : null);

        setSelectedDoctor(
          billingData.clientContactId
            ? String(billingData.clientContactId).split(",").map(Number)
            : [],
        );

        setUser(
          billingData.clientTeamMemberId
            ? billingData.clientTeamMemberId
            : null,
        );

        setSelectedCasePriority(
          billingData.priorityId ? billingData.priorityId : null,
        );

        setSelectedCaseType(
          billingData.caseTypeIdCsv
            ? billingData.caseTypeIdCsv.split(",").map(Number)
            : [],
        );

        setSelectedExamType(
          billingData.examTypeIdCsv
            ? billingData.examTypeIdCsv.split(",").map(Number)
            : [],
        );

        const getRateType =
          billingData.rateType == "Fixed" && billingData.flatRate > 0
            ? "Fixed"
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage > 0
              ? "Fixed Per Page"
              : billingData.rateType == "Fixed" &&
                  billingData.flatRatePerLine > 0
                ? "Fixed Per Line"
                : billingData.rateType == "Fixed" &&
                    billingData.rateTypeFlatRatePerHour > 0
                  ? "Fixed Per Hour"
                  : billingData.rateType == "PER_PAGE"
                    ? "Per Page"
                    : billingData.rateType == "PER_LINE"
                      ? "Per Line"
                      : "";

        setRateType(getRateType);

        const getFixedAmount =
          billingData.rateType == "Fixed" && billingData.flatRate
            ? billingData.flatRate
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage
              ? billingData.flatRatePerPage
              : billingData.rateType == "Fixed" && billingData.flatRatePerLine
                ? billingData.flatRatePerLine
                : billingData.rateType == "Fixed" &&
                    billingData.rateTypeFlatRatePerHour
                  ? billingData.rateTypeFlatRatePerHour
                  : "";

        setSelectedBaseCurrency(
          billingData.rateType == "Fixed" ||
            billingData.rateType == "Fixed Per Page" ||
            billingData.rateType == "Fixed Per Line" ||
            billingData.rateType == "Fixed Per Hour"
            ? billingData.currencyType
            : null,
        );

        setSelectedThresholdPageCurrency(
          getRateType == "Per Page" ? billingData.currencyType : null,
        );

        setSelectedThresholdLineCurrency(
          getRateType == "Per Line" ? billingData.currencyType : null,
        );

        setBaseAmount(getFixedAmount > 0 ? getFixedAmount : "");

        const getClientAmount =
          billingData.rateType == "Fixed" && billingData.clientRateTypeFlatRate
            ? billingData.clientRateTypeFlatRate
            : billingData.rateType == "Fixed" &&
                billingData.clientRateTypeFlatRatePerPage
              ? billingData.clientRateTypeFlatRatePerPage
              : billingData.rateType == "Fixed" &&
                  billingData.clientRateTypeFlatRatePerLine
                ? billingData.clientRateTypeFlatRatePerLine
                : billingData.rateType == "Fixed" &&
                    billingData.clientRateTypeFlatRatePerHour
                  ? billingData.clientRateTypeFlatRatePerHour
                  : "";

        setClientAmount(getClientAmount > 0 ? getClientAmount : "");

        const { slabs, pageType } = parsePageSlabsText(
          billingData.page_slabs_text,
        );

        setIsInputPages(getRateType == "Per Page" ? pageType : "");
        setThresholdPageData(getRateType == "Per Page" ? slabs : []);

        const parsedLine = parseThresholdLineString(
          billingData.line_slabs_text,
        );

        setThresholdLineData(getRateType == "Per Line" ? parsedLine : []);

        setBillingSnapshot({
          rateType: getRateType,
          baseAmount: billingData.flatRate > 0 ? billingData.flatRate : null,
          pageAmount:
            billingData.flatRatePerPage > 0
              ? billingData.flatRatePerPage
              : null,
          lineAmount:
            billingData.flatRatePerLine > 0
              ? billingData.flatRatePerLine
              : null,
          hourAmount:
            billingData.flatRatePerLine > 0
              ? billingData.flatRatePerLine
              : null,
          clientbaseAmount:
            billingData.clientRateTypeFlatRate > 0
              ? billingData.clientRateTypeFlatRate
              : null,
          clientpageAmount:
            billingData.clientRateTypeFlatRatePerPage > 0
              ? billingData.clientRateTypeFlatRatePerPage
              : null,
          clientlineAmount:
            billingData.clientRateTypeFlatRatePerLine > 0
              ? billingData.clientRateTypeFlatRatePerLine
              : null,
          clienthourAmount:
            billingData.clientRateTypeFlatRatePerHour > 0
              ? billingData.clientRateTypeFlatRatePerHour
              : null,
          pageType,
          pageSlabCurrency:
            getRateType == "Per Page" && billingData.currencyType
              ? billingData.currencyType
              : null,
          lineSlabCurrency:
            getRateType == "Per Line" && billingData.currencyType
              ? billingData.currencyType
              : null,
          pageSlabs: slabs,
          lineSlabs: parsedLine,
        });

        setEffectiveDateFrom(
          billingData.effectiveStartDate
            ? billingData.effectiveStartDate
            : null,
        );
        setEffectiveDateTo(
          billingData.effectiveEndDate ? billingData.effectiveEndDate : null,
        );
        setComments(billingData.comments ? billingData.comments : null);

        setIsActive(billingData.billingStatus == "Active" ? true : false);

        setCreatedOn(
          billingData.createdDate
            ? formatAppointmentDateTime(billingData.createdDate)
            : "",
        );

        setCreatedBy(
          billingData.createdByName ? billingData.createdByName : "",
        );

        const logData = await getBillingConfigChangeLog(
          selectedData.billingConfigId,
        );

        const filteredLogData = logData?.filter(
          (item: any) =>
            !["changedOn", "changedByName"].includes(
              item.fieldName?.toLowerCase(),
            ),
        );

        setChangeLogData(filteredLogData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedData) {
      getBillingDetails();
    }
  }, [selectedData]);

  useEffect(() => {
    console.log(selectedBaseCurrency, "UPDATED SB");
  }, [selectedBaseCurrency]);

  const applySnapshot = (snapshot: any) => {
    setRateType(snapshot.rateType);

    // clear everything first
    setBaseAmount("");
    setClientAmount("");
    setThresholdPageData([]);
    setThresholdLineData([]);
    setIsInputPages("");

    if (snapshot.rateType === "Fixed") {
      setBaseAmount(snapshot.baseAmount);
      setClientAmount(snapshot.clientbaseAmount);
    }
    if (snapshot.rateType === "Fixed Per Page") {
      setBaseAmount(snapshot.pageAmount);
      setClientAmount(snapshot.clientpageAmount);
    }
    if (snapshot.rateType === "Fixed Per Line") {
      setBaseAmount(snapshot.lineAmount);
      setClientAmount(snapshot.clientlineAmount);
    }
    if (snapshot.rateType === "Fixed Per Hour") {
      setBaseAmount(snapshot.hourAmount);
      setClientAmount(snapshot.clienthourAmount);
    }

    if (snapshot.rateType === "Per Page") {
      setIsInputPages(snapshot.pageType);
      setThresholdPageData(snapshot.pageSlabs);
      setSelectedThresholdPageCurrency(snapshot.pageSlabCurrency);
    }

    if (snapshot.rateType === "Per Line") {
      setThresholdLineData(snapshot.lineSlabs);
      setSelectedThresholdLineCurrency(snapshot.lineSlabCurrency);
    }

    // force table re-init
    setResetKey((k) => k + 1);
    getBillingDetails();
  };

  const handleRateTypeChange = (
    newType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Fixed Per Hour"
      | "Per Page"
      | "Per Line",
  ) => {
    setRateType(newType);

    if (!isEditMode) {
      setBaseAmount("");
      setClientAmount("");
      setThresholdPageData([]);
      setThresholdLineData([]);
      setThresholdErrors([]);
      setThresholdLineErrors([]);
      setResetKey((k) => k + 1);
      return;
    }

    if (!billingSnapshot) return;

    setBaseAmount("");
    setClientAmount("");
    setThresholdPageData([]);
    setThresholdLineData([]);

    if (newType === "Fixed") {
      setBaseAmount(billingSnapshot.baseAmount ?? "");
      setClientAmount(billingSnapshot.clientbaseAmount ?? "");
    }

    if (newType === "Fixed Per Page") {
      setBaseAmount(billingSnapshot.pageAmount ?? "");
      setClientAmount(billingSnapshot.clientpageAmount ?? "");
    }
    if (newType === "Fixed Per Line") {
      setBaseAmount(billingSnapshot.lineAmount ?? "");
      setClientAmount(billingSnapshot.clientlineAmount ?? "");
    }
    if (newType === "Fixed Per Hour") {
      setBaseAmount(billingSnapshot.hourAmount ?? "");
      setClientAmount(billingSnapshot.clienthourAmount ?? "");
    }

    if (newType === "Per Page") {
      setIsInputPages(billingSnapshot.pageType);
      setThresholdPageData(billingSnapshot.pageSlabs);
      setSelectedThresholdPageCurrency(billingSnapshot.pageSlabCurrency);
    }

    if (newType === "Per Line") {
      setThresholdLineData(billingSnapshot.lineSlabs);
      setSelectedThresholdLineCurrency(billingSnapshot.lineSlabCurrency);
    }

    setResetKey((k) => k + 1);
  };

  const handlePagesTypeChange = (newPageType: any) => {
    setIsInputPages(newPageType);

    if (!isEditMode) {
      setThresholdPageData([]);
      setThresholdErrors([]);
      setResetKey((k) => k + 1);
      return;
    }

    if (!billingSnapshot) return;

    setThresholdPageData([]);

    if (newPageType === billingSnapshot.pageType) {
      setThresholdPageData(billingSnapshot.pageSlabs);
    }

    setResetKey((k) => k + 1);
  };

  const handleIsActive = () => {
    setIsActive((prev) => !prev);
  };

  const parsePageSlabsText = (text: string) => {
    if (!text) return { slabs: [], pageType: "Input" as "Input" | "Output" };

    const rows = text
      .split("|")
      .map((r) => r.trim())
      .filter(Boolean);

    const slabs = rows.map((row) => {
      const [isInput, min, max, baseRate, clientRate] = row.split(",");

      return {
        isInputPage: Number(isInput) as 0 | 1,
        min: Number(min),
        max: Number(max),
        baseRate: baseRate,
        clientRate: clientRate,
      };
    });

    const pageType = slabs[0]?.isInputPage === 1 ? "Input" : "Output";

    return { slabs, pageType };
  };

  const parseThresholdLineString = (data?: string) => {
    if (!data) return [];

    return data.split("|").map((chunk) => {
      const [min, max, baseRate, clientRate] = chunk.trim().split(",");

      return {
        min: Number(min),
        max: Number(max),
        baseRate: baseRate,
        clientRate: clientRate,
      };
    });
  };

  const validateConfiguration = () => {
    const errors = [];

    if (!selectedRole) {
      errors.push("Please select User Role.");
    }

    if (!selectedCaseType || selectedCaseType?.length === 0) {
      errors.push("Case Type is mandatory.");
    }

    if (!selectedExamType || selectedExamType?.length === 0) {
      errors.push("Exam Type is mandatory.");
    }

    if (
      rateType == "Fixed" ||
      rateType == "Fixed Per Page" ||
      rateType == "Fixed Per Line" ||
      rateType == "Fixed Per Hour"
    ) {
      if (!baseAmount) {
        errors.push("Base Rate is mandatory.");
      }

      if (
        baseAmount === null ||
        baseAmount === undefined ||
        baseAmount === "" ||
        Number(baseAmount) === 0
      ) {
        errors.push("Base Rate cannot be zero.");
      }
      if (!clientAmount) {
        errors.push("Client Rate is mandatory.");
      }

      if (
        clientAmount === null ||
        clientAmount === undefined ||
        clientAmount === "" ||
        Number(clientAmount) === 0
      ) {
        errors.push("Client Rate cannot be zero.");
      }
    }

    if (rateType == "Per Page") {
      if (!thresholdPageData || thresholdPageData.length === 0) {
        errors.push("Please Add atleast one slab for per page");
      }
    }

    if (rateType == "Per Line") {
      if (!thresholdLineData || thresholdLineData.length === 0) {
        errors.push("Please Add atleast one slab for per line");
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateThreshold = () => {
    const errors = [];

    if (rateType == "Per Page") {
      if (thresholdErrors.length > 0) {
        errors.push(...thresholdErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateLineThreshold = () => {
    const errors = [];

    if (rateType == "Per Line") {
      if (thresholdLineErrors.length > 0) {
        errors.push(...thresholdLineErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (thresholdErrors.length > 0) {
      validateThreshold();
    }
  }, [thresholdErrors]);

  useEffect(() => {
    if (thresholdLineErrors.length > 0) {
      validateLineThreshold();
    }
  }, [thresholdLineErrors]);

  const getRateTypeForPayload = (rateType: string) => {
    switch (rateType) {
      case "Fixed":
      case "Fixed Per Page":
      case "Fixed Per Line":
      case "Fixed Per Hour":
        return RATE_TYPE.FLAT;
      case "Per Page":
        return RATE_TYPE.PER_PAGE;
      case "Per Line":
        return RATE_TYPE.PER_LINE;
      default:
        return rateType;
    }
  };

  const handleSave = async () => {
    if (!validateConfiguration()) return;
    setLoading(true);
    try {
      const payload: any = {
        ...(selectedData?.billingConfigId && {
          billingConfigId: selectedData.billingConfigId,
        }),

        webRoleId: selectedRole ? selectedRole : null,
        userId: null,
        clientId: selectedClient,
        clientContactIds: selectedDoctor ? selectedDoctor.join(",") : "",
        clientTeamMemberId: user ? user : null,
        priorityId: Number(selectedCasePriority),
        effectiveStartDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        effectiveEndDate: effectiveDateTo
          ? formatDateTime(effectiveDateTo)
          : null,
        caseTypeIdCsv: selectedCaseType.join(","),
        examTypeIdCsv: selectedExamType.join(","),
        rateType: getRateTypeForPayload(rateType),
        currencyType:
          rateType === "Per Page"
            ? thresholdPageCurrency
            : rateType === "Per Line"
              ? thresholdLineCurrency
              : selectedBaseCurrency,
        flatRate: rateType == "Fixed" ? baseAmount : 0,
        flatRatePerPage: rateType == "Fixed Per Page" ? baseAmount : 0,
        flatRatePerLine: rateType == "Fixed Per Line" ? baseAmount : 0,
        flatRatePerHour: rateType == "Fixed Per Hour" ? baseAmount : 0,
        clientRateTypeFlatRate: rateType == "Fixed" ? clientAmount : 0,
        clientRateTypeFlatRatePerPage:
          rateType == "Fixed Per Page" ? clientAmount : 0,
        clientRateTypeFlatRatePerLine:
          rateType == "Fixed Per Line" ? clientAmount : 0,
        clientRateTypeFlatRatePerHour:
          rateType == "Fixed Per Hour" ? clientAmount : 0,
        isPageThresholdAppl: rateType == "Per Page" ? 1 : 0,
        comments: comments,
        billingConfigStatus: isActive ? 1 : 0,
        modifiedBy: userID,
        createdBy: userID,
        pageSlabsText: rateType == "Per Page" ? formattedStringPerPage : null,
        lineSlabsText: rateType == "Per Line" ? formattedStringPerLine : null,
      };

      const saveBillingConfig = async () => {
        const api = selectedData?.billingConfigId
          ? updateBillingConfig
          : addBillingConfig;

        return api(payload);
      };

      const response = await saveBillingConfig();

      const successMessage = selectedData?.billingConfigId
        ? "Billing Configuration Updated Successfully"
        : "Billing Configuration Added Successfully";

      if (response.isSuccess) {
        setSnackbarMessage(successMessage);
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        setSnackbarMessage(response.message);
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChangeDrawer = async () => {
    if (selectedData) {
      setShowTooltip(false);
      setShowChangeDrawer(true);
    }
  };

  const handleCloseChangeDrawer = () => {
    setShowChangeDrawer(false);
  };

  const resetToDefault = async (val?: any) => {
    setSelectedRole("");

    const casePriorityData = await fetchPickListByGroupName(
      params.casePriority,
    );
    setCasePriorityOptions(casePriorityData);
    if (casePriorityData) {
      setSelectedCasePriority(casePriorityData[0]?.value);
    }
    setSelectedCaseType([]);
    setSelectedExamType([]);

    setRateType("Fixed");
    setSelectedBaseCurrency("USD");
    setBaseAmount("");
    setClientAmount("");

    setIsInputPages("Output");
    setThresholdPageData([]);
    setThresholdLineData([]);
    setThresholdErrors([]);
    setThresholdLineErrors([]);

    setEffectiveDateFrom(new Date());
    setEffectiveDateTo(addYears(new Date(), 1));

    setIsActive(true);
    setComments("");
  };

  const resetData = () => {
    if (!selectedData?.billingConfigId) {
      resetToDefault("By Role");
      return;
    }

    if (!billingSnapshot) return;

    setLoading(true);
    applySnapshot(billingSnapshot);
    setLoading(false);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = () => {
    resetData();
    setShowModalNew(false);
  };

  const [configurationBillingKey, setConfigurationBillingKey] = useState<
    string | null
  >("0");

  const [pageThresholdKey, setPageThresholdKey] = useState<string | null>("0");

  const handleAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (configurationBillingKey === key) {
      return; // do nothing
    }
    setConfigurationBillingKey(key || "0");
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={configurationBillingKey}
      onSelect={handleAccordionSelect}
    />
  );

  const thresholdAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={pageThresholdKey}
      onSelect={(key) => setPageThresholdKey(key as string)}
    />
  );

  const fixedSelected = [
    "Fixed",
    "Fixed Per Page",
    "Fixed Per Line",
    "Fixed Per Hour",
  ].includes(rateType);

  const filteredExamTypeOptions =
    selectedRoleLabel === WEB_ROLE.Historian
      ? examTypeOptions?.filter((opt: any) => opt.label !== "Supplemental")
      : examTypeOptions;

  return (
    <div>
      {" "}
      <div className="mt-4 mb-5">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {configurationAccordion([
          {
            title: "Configure Billing",
            content: (
              <>
                <Row className="align-items-center mt-0">
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Process / Role"
                      value={selectedRole}
                      options={webRoleOptions}
                      onChange={handleRoleChange}
                      name="webRoleID"
                      required={true}
                      disabled={selectedData}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Client"
                      value={selectedClient}
                      options={clientOptions}
                      onChange={(e) => {
                        setSelectedClient(e.target.value);
                        setSelectedDoctor([]);
                      }}
                      name="clientID"
                      required={true}
                      disabled={selectedData}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Doctor"
                      name="doctor"
                      options={doctorOptions}
                      values={selectedDoctor}
                      onChange={(e, name, values) => setSelectedDoctor(values)}
                      disabled={!selectedClient || selectedData}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="User"
                      value={user}
                      options={userOptions}
                      onChange={(e) => setUser(e.target.value)}
                      name="userID"
                      disabled={
                        !selectedClient || !selectedRole || selectedData
                      }
                    />
                  </Col>
                </Row>

                <Row className="align-items-center mt-3">
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Case Type"
                      name="caseType"
                      options={caseTypeOptions}
                      values={selectedCaseType}
                      onChange={(e, name, values) =>
                        setSelectedCaseType(values)
                      }
                      required
                      isSelectAll={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Exam Type"
                      name="examType"
                      options={filteredExamTypeOptions}
                      values={selectedExamType}
                      onChange={(e, name, values) =>
                        setSelectedExamType(values)
                      }
                      required
                      isSelectAll={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Case Proirity"
                      value={selectedCasePriority}
                      options={casePriorityOptions}
                      onChange={(e) => setSelectedCasePriority(e.target.value)}
                      name="casePriority"
                      required={true}
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mt-3">
                  <div className="col-md-8 col-xxl-4">
                    <div className="rate-type-wrapper">
                      {/* Fixed */}
                      <div className="rate-type-block adjust_spacingToggle">
                        <div className="rate-type-label">
                          Rate Type (Fixed)
                          <span style={{ color: "#0092d5" }}>
                            {fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeMain"
                          value={rateType}
                          onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="fixed-rate"
                            variant="outline-secondary"
                            value="Fixed"
                            className="px-3"
                          >
                            Fixed
                          </ToggleButton>

                          <ToggleButton
                            id="per-page-main"
                            variant="outline-secondary"
                            value="Fixed Per Page"
                            className="px-3"
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-main"
                            variant="outline-secondary"
                            value="Fixed Per Line"
                            className="px-3"
                          >
                            Per Line
                          </ToggleButton>
                          <ToggleButton
                            id="per-hour-main"
                            variant="outline-secondary"
                            value="Fixed Per Hour"
                            className="px-3"
                          >
                            Per Hour
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>

                      {/* Pipe */}
                      <div className="rate-type-pipe">||</div>

                      {/* Slab */}
                      <div className="rate-type-block">
                        <div className="rate-type-label">
                          Rate Type (Slab)
                          <span style={{ color: "#0092d5" }}>
                            {!fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeSlab"
                          value={rateType}
                          onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="per-page-slab"
                            variant="outline-secondary"
                            value="Per Page"
                            className="px-3"
                            disabled={!selectedRole || !isSlabDisable}
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-slab"
                            variant="outline-secondary"
                            value="Per Line"
                            className="px-3"
                            disabled={!selectedRole || !isSlabDisable}
                          >
                            Per Line
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </div>
                  </div>

                  {rateType === "Per Page" && (
                    <>
                      <Col
                        sm="3"
                        className="fw-semibold ps-1 form-label-fixed d-flex align-items-center adjust_spacingToggle"
                      >
                        Slab Apply on Pages
                        <ToggleButtonGroup
                          type="radio"
                          name="inputPagesType"
                          value={isInputPages}
                          onChange={handlePagesTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="input-page"
                            variant="outline-secondary"
                            value="Input"
                            className="px-3"
                            disabled={!isSlabDisable}
                          >
                            Input
                          </ToggleButton>

                          <ToggleButton
                            id="output-page"
                            variant="outline-secondary"
                            value="Output"
                            className="px-3"
                            disabled={!isSlabDisable}
                          >
                            Output
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                    </>
                  )}
                </Row>

                <Row className="align-items-center mt-3">
                  {(rateType === "Fixed" ||
                    rateType === "Fixed Per Page" ||
                    rateType === "Fixed Per Line" ||
                    rateType === "Fixed Per Hour") && (
                    <>
                      <Col sm={3}>
                        <CurrencyInputWithType
                          label="Base Rate"
                          name="base"
                          value={baseAmount}
                          onChange={(e) => setBaseAmount(e.target.value)}
                          allowDecimal={true}
                          limit={[8, 2]}
                          showAmountLabel={true}
                          currencyOptions={currencyOptions}
                          selectedCurrency={selectedBaseCurrency}
                          onCurrencyChange={(val) =>
                            setSelectedBaseCurrency(val)
                          }
                        />
                      </Col>
                      <Col sm={3}>
                        <CurrencyInputWithType
                          label="Client Rate"
                          name="client"
                          value={clientAmount}
                          onChange={(e) => setClientAmount(e.target.value)}
                          allowDecimal={true}
                          limit={[8, 2]}
                          disabled={!selectedClientCurrency}
                          showAmountLabel={true}
                          currencyOptions={currencyOptions}
                          selectedCurrency={selectedClientCurrency}
                          onCurrencyChange={(val) =>
                            setSelectedClientCurrency(val)
                          }
                          currencyDisabled={true}
                        />
                      </Col>
                    </>
                  )}
                </Row>

                {rateType == "Per Page" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title:
                          isInputPages === "Input"
                            ? "Input Page Slab"
                            : "Output Page Slab",
                        content: (
                          <ThresholdEditableTable
                            resetKey={resetKey}
                            isInputPages={isInputPages}
                            value={thresholdPageData}
                            canAdd={true}
                            onChange={setThresholdPageData}
                            onValidationError={setThresholdErrors}
                            setSelectedCurrency={
                              setSelectedThresholdPageCurrency
                            }
                            selectedThresholdPageCurrency={
                              thresholdPageCurrency
                            }
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                {rateType == "Per Line" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title: "Line Slab",
                        content: (
                          <ThresholdLineEditable
                            resetKey={resetKey}
                            value={thresholdLineData}
                            canAdd={true}
                            onChange={setThresholdLineData}
                            onValidationError={setThresholdLineErrors}
                            setSelectedCurrency={
                              setSelectedThresholdLineCurrency
                            }
                            selectedThresholdLineCurrency={
                              thresholdLineCurrency
                            }
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                <Row className="align-items-center mt-3">
                  <div className="col-md-3  col-xxl-2">
                    <FloatingLabelDatepicker
                      ref={datePickerRef}
                      label="Effective Date From"
                      name="effectiveDateFrom"
                      value={effectiveDateFrom}
                      onChange={(date: Date | null) => {
                        setEffectiveDateFrom(date);
                      }}
                      required
                      dateFormat="MM/dd/yyyy"
                      maxDate={effectiveDateTo || undefined}
                    />
                  </div>

                  <div className="col-md-3 col-xxl-2">
                    <FloatingLabelDatepicker
                      ref={datePickerRef}
                      label="Effective Date To"
                      value={effectiveDateTo}
                      onChange={setEffectiveDateTo}
                      dateFormat="MM/dd/yyyy"
                      minDate={effectiveDateFrom || undefined}
                      canClear
                      autoComplete="new-password"
                      inputMode="none"
                      placeholder=" "
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === "Backspace" || e.key === "Delete") {
                          e.preventDefault();
                          setEffectiveDateTo(null);
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-4 col-sm-6">
                    <div className="d-flex align-items-center toggle-btn">
                      <span className="me-3 fw-semibold">Status</span>

                      <Form.Check
                        type="switch"
                        id="sort-switch"
                        checked={isActive}
                        onChange={handleIsActive}
                      />
                      <span className="ms-2">
                        {isActive ? "Active" : "In Active"}
                      </span>
                    </div>
                  </div>
                </Row>
                <Col
                  sm={12}
                  className="mt-3 notemultiline notemultilinerushnote  mb-3"
                >
                  <MultilineTextBox
                    label="Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={100}
                  />
                </Col>
                <Row className="mt-3 mb-3">
                  <Col sm={12} className="d-flex align-items-center">
                    {changeLogData?.length > 0 && (
                      <OverlayTrigger
                        show={showTooltip}
                        placement="auto"
                        trigger={["hover", "focus"]}
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <div className="d-flex">
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handleOpenChangeDrawer}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </Button>
                        </div>
                      </OverlayTrigger>
                    )}

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center me-auto btn-text-border"
                      onClick={onClose}
                    >
                      <span className="material-icons me-1">arrow_back</span>
                      Back
                    </Button>

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancelButton}
                    >
                      <span className="material-icons me-1">close</span>
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSave}
                    >
                      <span className="material-icons me-1">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}

        <ChangeLogDrawer
          title={"Change Log"}
          open={showChangeDrawer}
          onClose={handleCloseChangeDrawer}
          placement="bottom"
          data={changeLogData}
          createdOn={createdOn}
          createdBy={createdBy}
        >
          <BillingDataTable
            headers={BILLING_CONFIG_CHANGE_LOG}
            rows={changeLogData}
            isLogTable={true}
          />
        </ChangeLogDrawer>
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default AddUpdateConfiguration;
